<div class="no-select">
  <div class="mt-2">
    <div class="border rounded-1 pt-2 mb-3 filter-container record-container"
      [ngClass]="_totalRecords() > 30 ? 'record-container-high' : ''" >
      <div class="d-flex">
        <div class="btn-control-box pl-3">
          <div class="btn-control-box-content">
            @for (controlPoint of assignedControlPoints(); track controlPoint; let i = $index) {
              <span class="control-point">
                <a class="btn btn-primary c-item"
                  (click)="changeTab(controlPoint.controlPointId,i)"
                  [ngClass]="{'active':activeControlPointIndex() == i}"
                  [title]="controlPoint.name">
                  {{controlPoint.name | slice:0:10}}
                </a>
              </span>
            }
          </div>
        </div>
        <div class="create d-flex justify-content-end new-record">

          <button class="secondary-button multi-assignment mr-1"  (click)="assignMultiRecords()"
            style="width: 12rem !important;">
            <img src="assets/icon/multi-assignment.svg"  alt="multi-assignment"/>
            <span class="text-size"> {{'BUTTONS.MULTI_ASSIGNMENT' | translate}}</span>
          </button>
          <button class="ms-2 me-3 btn btn-primary action-button" (click)="onRecordClick()">

            <i
            class="fas fas fa-plus-circle" style="padding-right:5px"></i>
            {{'BUTTONS.NEW_RECORD' | translate}}
          </button>
        </div>
      </div>

      <div class="filter">
        <div class="form-check form-check-inline">
          <input class="form-check-input" type="radio" name="typeRecord" id="option1" value="assigned" (change)="filterRecords('assigned')" [ngModel]="selectedOption()">
          <label class="form-check-label text-size" for="option1">
            {{'MESSAGE_INFO.ASSIGNED_RECORDS' | translate}}
          </label>
        </div>
        <div class="form-check form-check-inline">
          <input class="form-check-input" type="radio" name="typeRecord" id="option2" value="unAssigned" (change)="filterRecords('unAssigned')" [ngModel]="selectedOption()">
          <label class="form-check-label text-size" for="option2">
            {{'MESSAGE_INFO.UNASSIGNED_RECORDS' | translate}}
          </label>
        </div>
        <div class="form-check form-check-inline">
          <input class="form-check-input" type="radio" name="typeRecord" id="option3" value="all" (change)="filterRecords('all')" checked [ngModel]="selectedOption()">
          <label class="form-check-label text-size" for="option3">
            {{'MESSAGE_INFO.ALL' | translate}}
          </label>
        </div>
      </div>
      @if (_vibrationRecords() != undefined) {
        <div class="border-2 m-2 rounded-1">
          @if (_totalRecords() > 30) {
            <div class="d-flex justify-content-end mt-3">
              <nav aria-label="Page navigation">
                <ul class="pagination">
                  <li class="page-item" [class.disabled]="currentPage() === 1">
                    <a class="page-link" (click)="goToPage(1)" aria-label="First">
                      <span aria-hidden="true">««</span>
                    </a>
                  </li>
                  <li class="page-item" [class.disabled]="currentPage() === 1">
                    <a class="page-link" (click)="goToPage(currentPage() - 1)" aria-label="Previous">
                      <span aria-hidden="true">«</span>
                    </a>
                  </li>
                  @for (page of pages(); track page) {
                    <li class="page-item" [class.active]="currentPage() === page">
                      <a class="page-link" (click)="goToPage(page)">{{ page }}</a>
                    </li>
                  }
                  <li class="page-item" [class.disabled]="currentPage() === totalPages()">
                    <a class="page-link" (click)="goToPage(currentPage() + 1)" aria-label="Next">
                      <span aria-hidden="true">»</span>
                    </a>
                  </li>
                  <li class="page-item" [class.disabled]="currentPage() === totalPages()">
                    <a class="page-link" (click)="goToPage(totalPages())" aria-label="Last">
                      <span aria-hidden="true">»»</span>
                    </a>
                  </li>
                </ul>
              </nav>
            </div>
          }
          @if (controlPoints != undefined) {
            <app-record-detail [siteId]="siteId"  [vibrationRecords]="filteredRecords()" [selectedRecordIndex]="1"
            [controlPoints]="controlPoints" [isDetailsVisible]="isDetailsVisible()"
            (recordsChanged)="loadVibrationRecords()"></app-record-detail>
          }
        </div>
      }
      @if (_vibrationRecords() == undefined || _vibrationRecords()!.length == 0) {
        <span   class="no-records text-size">
          {{'RECORD.NO_RECORDS' | translate}}
        </span>
      }
    </div>
  </div>
</div>
